import { useCallback, useState } from "react";
import {
  startFieldReannotation,
  type BatchJob,
  type FieldAnnotationState,
  type FieldReannotationField,
} from "../../../../../lib/corpusApi";
import type { BatchJobParamsForm } from "../../batch_job_kind_contract";
import { useDocumentScope, type DocumentScopeState } from "../../useDocumentScope";

export interface UseFieldReannotationParamsResult extends BatchJobParamsForm, DocumentScopeState {
  field: FieldReannotationField;
  setField: (field: FieldReannotationField) => void;
  annotationState: FieldAnnotationState;
  setAnnotationState: (annotationState: FieldAnnotationState) => void;
}

/** The params a field_reannotation job is started with: which field to re-annotate, over which
 *  documents, and in which annotation state. All always have a value, so the job can always be started. */
export function useFieldReannotationParams(): UseFieldReannotationParamsResult {
  const documentScope = useDocumentScope("ingested");
  const { scope } = documentScope;
  const [field, setField] = useState<FieldReannotationField>("study_type");
  const [annotationState, setAnnotationState] = useState<FieldAnnotationState>("any");

  const start = useCallback(
    (name?: string): Promise<BatchJob> =>
      startFieldReannotation({ scope, field, annotationState, name }),
    [scope, field, annotationState]
  );

  return {
    ...documentScope,
    field,
    setField,
    annotationState,
    setAnnotationState,
    canStart: true,
    start,
  };
}
